const policyNames = {
	FIRE: 'Vyapar Suraksha',
	FIRE_ALL_RISK: 'Vyapar Suraksha',
}

export const getPolicyName = tag => policyNames[tag]
